import type { SVGProps } from 'react';
const SvgIconToggle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.75 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.75 2.25a5.75 5.75 0 0 1 0 11.5h-3.5a5.75 5.75 0 0 1 0-11.5zm-3.5 1.5a4.25 4.25 0 0 0 0 8.5h3.5a4.25 4.25 0 0 0 0-8.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconToggle;
